// import React, { useState, useEffect } from "react";
// import FormField from "../../../components/ui/FormField";
// import { Button } from "../../../components/Button";

// const ShTenForm = () => {
//     const [records, setRecords] = useState(() => {
//         const saved = localStorage.getItem("sh10_data");
//         return saved ? JSON.parse(saved) : [{
//             id: Date.now(),
//             header: {},
//             transactions: [{ id: Date.now() + 1 }]
//         }];
//     });
//     useEffect(() => {
//         localStorage.setItem("sh10_data", JSON.stringify(records));
//     }, [records]);

//     const updateHeader = (id, field, value) => {
//         setRecords(prev => prev.map(rec =>
//             rec.id === id ? { ...rec, header: { ...rec.header, [field]: value } } : rec
//         ));
//     };

//     const updateTransaction = (recId, transId, field, value) => {
//         setRecords(prev => prev.map(rec => {
//             if (rec.id !== recId) return rec;
//             return {
//                 ...rec,
//                 transactions: rec.transactions.map(t =>
//                     t.id === transId ? { ...t, [field]: value } : t
//                 )
//             };
//         }));
//     };

//     const addTransaction = (id) => {
//         setRecords(prev => prev.map(rec =>
//             rec.id === id ? { ...rec, transactions: [...rec.transactions, { id: Date.now() }] } : rec
//         ));
//     };

//     const addNewFolio = () => {
//         setRecords([...records, { id: Date.now(), header: {}, transactions: [{ id: Date.now() + 1 }] }]);
//     };

//     const handleSave = () => {
//   const payload = {
//     formType: "SH-10",
//     generatedAt: new Date().toISOString(),
//     totalFolioRecords: records.length,
//     records: records.map(({ id, header, transactions }) => ({
//       folioId: id,
//       header: {
//         compName: header.compName || "",
//         office: header.office || "",
//         specResDate: header.specResDate || "",
//         boardAppDate: header.boardAppDate || "",
//         authDetails: header.authDetails || "",
//         offerPeriod: header.offerPeriod || "",
//         completionDate: header.completionDate || "",
//         secDesc: header.secDesc || "",
//         signatoryName: header.signatoryName || "",
//         designation: header.designation || "",
//         place: header.place || "",
//         currentDate: header.currentDate || "",
//         otherDetails: header.otherDetails || ""
//       },
//       transactions: transactions.map(({ id, ...t }) => ({
//         sno: t.sno || "",
//         folioNo: t.folioNo || "",
//         holderName: t.holderName || "",
//         category: t.category || "",
//         buyBackDate: t.buyBackDate || "",
//         qty: t.qty || "",
//         mode: t.mode || "",
//         nominalVal: t.nominalVal || "",
//         buyPrice: t.buyPrice || "",
//         payDate: t.payDate || "",
//         totalPaid: t.totalPaid || "",
//         cumTotal: t.cumTotal || "",
//         cancelDate: t.cancelDate || "",
//         refMem: t.refMem || "",
//         remarks: t.remarks || ""
//       }))
//     }))
//   };

//   console.log("SH-10 FINAL PAYLOAD", JSON.stringify(payload, null, 2));
// };

//     return (
//         <div>
//             <div className="bg-white border-b-2 px-6 py-2 mb-8 text-center shadow-sm">
//                 <h1 className="text-xl font-bold uppercase">Form No. SH - 10</h1>
//                 <h2 className="text-lg font-semibold">Register of shares or other securities bought-back</h2>
//                 <p className="text-[10px] italic text-gray-600 mt-1">
//                     [Pursuant to sub-section (9) of section 68 of the Companies Act, 2013 and rule 17 (12) of the Companies (Share Capital and Debentures) Rules 2014]
//                 </p>
//             </div>

//             {records.map((record, rIdx) => (
//                 <div key={record.id} className="bg-white border border-gray-300 rounded-lg shadow-md mb-2 overflow-hidden">
//                     <div className="bg-primary text-white px-6 py-2 flex justify-between items-center">
//                         <span className="font-bold text-sm tracking-widest uppercase">Buy-Back Folio #{rIdx + 1}</span>
//                         {records.length > 1 && (
//                             <button
//                                 onClick={() => setRecords(records.filter(r => r.id !== record.id))}
//                                 className="bg-red-600 hover:bg-red-700 text-[10px] px-3 py-1 rounded font-bold uppercase transition"
//                             >
//                                 Delete Folio
//                             </button>
//                         )}
//                     </div>

//                     <div className="p-2 space-y-4">
//                         <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
//                             <FormField label="Name of Company" value={record.header.compName} onChange={(v) => updateHeader(record.id, 'compName', v)} />
//                             <FormField label="Registered office address" type="description" value={record.header.office} onChange={(v) => updateHeader(record.id, 'office', v)} />

//                             <FormField label="1. Date of passing special resolution at the meeting of the members authorizing buy-back of securities" type="date" value={record.header.specResDate} onChange={(v) => updateHeader(record.id, 'specResDate', v)} />
//                             <FormField label="2. Date of approval by the Board" type="date" value={record.header.boardAppDate} onChange={(v) => updateHeader(record.id, 'boardAppDate', v)} />

//                             <FormField label="3. Number, price and amount of shares or other specified securities authorized to be bought back" type="description" value={record.header.authDetails} onChange={(v) => updateHeader(record.id, 'authDetails', v)} />
//                             <FormField label="4. Date of opening and closing of buy-back offer" value={record.header.offerPeriod} onChange={(v) => updateHeader(record.id, 'offerPeriod', v)} />

//                             <FormField label="5. Date by which buy-back was completed" type="date" value={record.header.completionDate} onChange={(v) => updateHeader(record.id, 'completionDate', v)} />
//                             <FormField label="6. Description of shares or other specified securities bought back by the company" type="description" value={record.header.secDesc} onChange={(v) => updateHeader(record.id, 'secDesc', v)} />
//                         </div>

//                         <div className="border-t-2 border-gray-100 pt-4">
//                             <div className="flex justify-between items-center mb-2">
//                                 <h3 className="font-bold text-sm underline uppercase tracking-tight text-slate-700">Ledger Entry (Columns 1-15)</h3>
//                                 <button
//                                     onClick={() => addTransaction(record.id)}
//                                     className="bg-primary hover:bg-blue-700 text-white text-[10px] px-4 py-2 rounded-md font-bold uppercase shadow-sm transition"
//                                 >
//                                     + Add New Transaction
//                                 </button>
//                             </div>

//                             {record.transactions.map((trans, tIdx) => (
//                                 <div key={trans.id} className="mb-2 border border-slate-200 rounded-lg p-2 grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-2 relative">
//                                     <div className="col-span-full border-b border-slate-200 pb-2 mb-1 flex justify-between items-center">
//                                         <span className="font-black text-[10px] text-slate-400 uppercase">Entry Serial No: {tIdx + 1}</span>
//                                         {record.transactions.length > 1 && (
//                                             <button onClick={() => updateTransaction(record.id, trans.id, 'delete', true)} className="text-red-400 text-[10px] hover:text-red-600 font-bold uppercase">Remove Entry</button>
//                                         )}
//                                     </div>

//                                     <FormField label="(1) S.No" value={trans.sno} onChange={(v) => updateTransaction(record.id, trans.id, 'sno', v)} />
//                                     <FormField label="(2) Folio number / DP Id/ client ID / certificate number" value={trans.folioNo} onChange={(v) => updateTransaction(record.id, trans.id, 'folioNo', v)} />
//                                     <FormField label="(3) Name of last holder of securities" value={trans.holderName} onChange={(v) => updateTransaction(record.id, trans.id, 'holderName', v)} />
//                                     <FormField label="(4) Category of securities (e.g. Equity, ESOP, etc.)" value={trans.category} onChange={(v) => updateTransaction(record.id, trans.id, 'category', v)} />
//                                     <FormField label="(5) Date of buy-back" type="date" value={trans.buyBackDate} onChange={(v) => updateTransaction(record.id, trans.id, 'buyBackDate', v)} />
//                                     <FormField label="(6) Number of securities bought-back" type="number" value={trans.qty} onChange={(v) => updateTransaction(record.id, trans.id, 'qty', v)} />
//                                     <FormField label="(7) Mode of buy-back" value={trans.mode} onChange={(v) => updateTransaction(record.id, trans.id, 'mode', v)} />
//                                     <FormField label="(8) Nominal value of securities" value={trans.nominalVal} onChange={(v) => updateTransaction(record.id, trans.id, 'nominalVal', v)} />
//                                     <FormField label="(9) Price at which securities are bought back" value={trans.buyPrice} onChange={(v) => updateTransaction(record.id, trans.id, 'buyPrice', v)} />
//                                     <FormField label="(10) Date of payment" type="date" value={trans.payDate} onChange={(v) => updateTransaction(record.id, trans.id, 'payDate', v)} />
//                                     <FormField label="(11) Amount paid for bought back securities" value={trans.totalPaid} onChange={(v) => updateTransaction(record.id, trans.id, 'totalPaid', v)} />
//                                     <FormField label="(12) Cumulative total of securities bought-back" value={trans.cumTotal} onChange={(v) => updateTransaction(record.id, trans.id, 'cumTotal', v)} />
//                                     <FormField label="(13) Date of cancellation / physical destruction" type="date" value={trans.cancelDate} onChange={(v) => updateTransaction(record.id, trans.id, 'cancelDate', v)} />
//                                     <FormField label="(14) Reference to entry in Register of members" value={trans.refMem} onChange={(v) => updateTransaction(record.id, trans.id, 'refMem', v)} />
//                                     <div className="col-span-1 md:col-span-2">
//                                         <FormField label="(15) Remarks" type="description" value={trans.remarks} onChange={(v) => updateTransaction(record.id, trans.id, 'remarks', v)} />
//                                     </div>
//                                 </div>
//                             ))}
//                         </div>

//                         <div className="border-t-2 border-gray-100 pt-3 grid grid-cols-1 md:grid-cols-1 gap-2">
//                                 <h4 className="font-bold text-xs uppercase text-slate-500">Authorized Signatory</h4>
//                             <div className="grid grid-cols-2 gap-2">
//                                 <FormField label="Name of the Person" value={record.header.signatoryName} onChange={(v) => updateHeader(record.id, 'signatoryName', v)} />
//                                 <FormField label="Designation" value={record.header.designation} onChange={(v) => updateHeader(record.id, 'designation', v)} />
//                                     <FormField label="Place" value={record.header.place} onChange={(v) => updateHeader(record.id, 'place', v)} />
//                                     <FormField label="Date" type="date" value={record.header.currentDate} onChange={(v) => updateHeader(record.id, 'currentDate', v)} />
//                             </div>
//                             <FormField label="2. Other relevant details, if any" type="description" value={record.header.otherDetails} onChange={(v) => updateHeader(record.id, 'otherDetails', v)} />

//                         </div>
//                     </div>
//                 </div>
//             ))}

//             <div className="flex flex-row justify-between items-center mb-4">
//                 <Button
//             label='Create New SH-10 Register Record'
//                 onClick={addNewFolio}
//                 className="mt-2 mr-2 ml-3"
//             />
//             <Button
//             label='Save'
//                 onClick={handleSave}
//                 className="mt-2 ml-2 mr-9"
//             />
//             </div>

//         </div>
//     );
// };

// export default ShTenForm;
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import FormField from "../../../components/ui/FormField";
import { Button } from "../../../components/Button";
import { sh10RegisterApi } from "../../../api/Sh10RegisterApi";
import { ArrowLeft, Plus, Trash2 } from "lucide-react";

// Map transaction entry → backend DTO
const mapTransactionToEntry = (trans) => ({
  folioNumber: trans.folioNo || null,
  dpIdClientId: trans.dpIdClientId || null,
  certificateNumber: trans.certNo || null,
  holderName: trans.holderName || null,
  category: trans.category || null,
  buybackDate: trans.buyBackDate || null,
  numberOfSecurities: trans.qty ? parseInt(trans.qty, 10) : null,
  modeOfBuyback: trans.mode || null,
  nominalValue: trans.nominalVal ? parseFloat(trans.nominalVal) : null,
  buybackPrice: trans.buyPrice ? parseFloat(trans.buyPrice) : null,
  paymentDate: trans.payDate || null,
  amountPaid: trans.totalPaid ? parseFloat(trans.totalPaid) : null,
  cumulativeTotal: trans.cumTotal ? parseFloat(trans.cumTotal) : null,
  cancellationDate: trans.cancelDate || null,
  registerMemberReference: trans.refMem || null,
  remarks: trans.remarks || null,
});

const createDefaultTransaction = () => ({ id: Date.now() + Math.random() });

// ✅ Single record — no array of records anymore
const createDefaultRecord = () => ({
  header: {},
  transactions: [createDefaultTransaction()],
});

const ShTenForm = () => {
  const token = useSelector((state) => state.auth.access_token);
  const companies = useSelector((state) => state.account.accountDetails);

  const [accountId, setAccountId] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  // ✅ Single record object instead of array of records
  const [record, setRecord] = useState(() => {
    const saved = localStorage.getItem("sh10_data");

    if (saved) {
      const parsed = JSON.parse(saved);

      return {
        header: parsed.header || {},
        transactions: parsed.transactions || [createDefaultTransaction()],
      };
    }

    return createDefaultRecord();
  });
  useEffect(() => {
    localStorage.setItem("sh10_data", JSON.stringify(record));
  }, [record]);

  const handleCompanyChange = (e) => {
    const selectedValue = e.target.value;
    if (selectedValue === "") {
      setAccountId("");
      return;
    }
    const selectedCompany = companies.find(
      (company) => String(company.id) === String(selectedValue),
    );
    if (selectedCompany) {
      setAccountId(selectedCompany.id);
    } else {
      console.error("Company not found for value:", selectedValue);
    }
  };

  // ✅ Simplified — no record id needed
  const updateHeader = (field, value) => {
    setRecord((prev) => ({
      ...prev,
      header: { ...prev.header, [field]: value },
    }));
  };

  const updateTransaction = (transId, field, value) => {
    setRecord((prev) => ({
      ...prev,
      transactions: prev.transactions.map((t) =>
        t.id === transId ? { ...t, [field]: value } : t,
      ),
    }));
  };

  const addTransaction = () => {
    setRecord((prev) => ({
      ...prev,
      transactions: [...prev.transactions, createDefaultTransaction()],
    }));
  };

  const removeTransaction = (transId) => {
    if (record.transactions.length <= 1) return;
    setRecord((prev) => ({
      ...prev,
      transactions: prev.transactions.filter((t) => t.id !== transId),
    }));
  };

  const handleSave = async () => {
    if (!accountId) {
      setSubmitStatus({
        type: "error",
        message: "Please select a company before saving.",
      });
      return;
    }

    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      const h = record.header;

      const payload = {
        specialResolutionDate: h.specResDate || null,
        boardApprovalDate: h.boardAppDate || null,
        authorizedNumberOfSecurities: h.authCount
          ? parseInt(h.authCount, 10)
          : null,
        authorizedPrice: h.authPrice ? parseFloat(h.authPrice) : null,
        authorizedAmount: h.authAmount ? parseFloat(h.authAmount) : null,
        buybackOpeningDate: h.offerOpenDate || null,
        buybackClosingDate: h.offerCloseDate || null,
        buybackCompletionDate: h.completionDate || null,
        descriptionOfSecurities: h.secDesc || null,
        place: h.place || null,
        date: h.currentDate || null,
        authorizedPersonName: h.signatoryName || null,
        designation: h.designation || null,
        entries: record.transactions.map(mapTransactionToEntry),
      };

      await sh10RegisterApi.submitSh10Form(payload, accountId, token);

      setSubmitStatus({
        type: "success",
        message: "SH-10 Register data saved successfully!",
      });
      localStorage.removeItem("sh10_data");
    } catch (error) {
      setSubmitStatus({
        type: "error",
        message:
          error.message ||
          "Failed to save SH-10 register data. Please try again.",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div>
      {/* Header */}
      <div className="bg-white border-b-4 p-3 mb-2 text-center shadow-sm rounded-xl relative">
        <button
            onClick={() => window.history.back()}
            className="absolute top-3 left-4 flex items-center gap-2 text-gray-600 hover:text-gray-900"
        >
            <ArrowLeft size={18} />
            <span className="text-sm font-medium">Back</span>
        </button>
        <h1 className="text-2xl font-black uppercase tracking-tight">Form No. SH - 10</h1>
        <h2 className="text-xl font-bold mt-1">
          Register of shares or other securities bought-back
        </h2>
        <p className="text-[10px] italic text-slate-500 mt-2 max-w-3xl mx-auto">
          [Pursuant to sub-section (9) of section 68 of the Companies Act, 2013
          and rule 17(12) of the Companies (Share Capital and Debentures) Rules
          2014]
        </p>
      </div>

      {/* Company Selection */}
      <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-3 mb-1">
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Name of the company *
        </label>
        <select
          value={accountId}
          onChange={handleCompanyChange}
          className="w-50 px-2 py-1 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          <option value="">Select a company</option>
          {companies.map((company) => (
            <option key={company.id} value={company.id}>
              {company.accountName || `Company ${company.id}`}
            </option>
          ))}
        </select>
      </div>

      {/* Status Message */}
      {submitStatus && (
        <div
          className={`mb-3 px-4 py-1 rounded-lg text-sm font-medium border ${
            submitStatus.type === "success"
              ? "bg-green-50 text-green-800 border-green-200"
              : "bg-red-50 text-red-800 border-red-200"
          }`}
        >
          {submitStatus.message}
        </div>
      )}

      {/* Single SH-10 Record */}
      <div className="bg-white border border-slate-200 rounded-xl shadow-md overflow-hidden transition-all hover:shadow-lg mb-2">
        <div className="bg-primary text-white px-3 py-2">
          <span className="font-semibold text-sm uppercase tracking-widest text-white">
            SH-10 Register Details
          </span>
        </div>

        <div className="p-3 space-y-2">
          {/* Header Fields */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2">
            <FormField
              label="1. Date of passing special resolution"
              type="date"
              value={record.header?.specResDate || ""}
              onChange={(v) => updateHeader("specResDate", v)}
            />
            <FormField
              label="2. Date of approval by the Board"
              type="date"
              value={record.header.boardAppDate}
              onChange={(v) => updateHeader("boardAppDate", v)}
            />
            <FormField
              label="3. Authorized number of securities"
              type="number"
              value={record.header.authCount}
              onChange={(v) => updateHeader("authCount", v)}
            />
            <FormField
            type="number"
              label="Authorized price per security"
              value={record.header.authPrice}
              onChange={(v) => updateHeader("authPrice", v)}
            />
            <FormField
            type="number"
              label="Authorized amount"
              value={record.header.authAmount}
              onChange={(v) => updateHeader("authAmount", v)}
            />
            <FormField
              label="4. Buy-back offer opening date"
              type="date"
              value={record.header.offerOpenDate}
              onChange={(v) => updateHeader("offerOpenDate", v)}
            />
            <FormField
              label="Buy-back offer closing date"
              type="date"
              value={record.header.offerCloseDate}
              onChange={(v) => updateHeader("offerCloseDate", v)}
            />
            <FormField
              label="5. Date by which buy-back was completed"
              type="date"
              value={record.header.completionDate}
              onChange={(v) => updateHeader("completionDate", v)}
            />
            <FormField
              label="6. Description of securities bought back"
              type="description"
              value={record.header.secDesc}
              onChange={(v) => updateHeader("secDesc", v)}
            />
          </div>

          {/* Transactions */}
          <div className="border-t-2 border-slate-100 pt-3">
            <div className="flex justify-between items-center mb-2">
              <h3 className="font-bold text-base uppercase tracking-tight text-slate-700">
                Ledger Entries
              </h3>
              <button
                onClick={addTransaction}
                type="button"
                className="bg-primary text-white text-sm gap-1 px-3 py-1.5 rounded flex flex-row items-center"
              >
                <Plus size={18}/> <span>Add New Transaction</span>
              </button>
            </div>

            {record.transactions.map((trans, tIdx) => (
              <div
                key={trans.id}
                className="mb-2 border border-slate-200 rounded-lg p-3 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2"
              >
                <div className="col-span-full border rounded-lg border-slate-100 px-3 py-1 mb-1 bg-primary flex justify-between items-center">
                  <span className=" p-2 font-black text-[10px] text-slate-100 uppercase">
                    Entry Serial No: {tIdx + 1}
                  </span>
                  {record.transactions.length > 1 && (
                    <button
                      onClick={() => removeTransaction(trans.id)}
                      className="text-red-600 bg-white p-1 rounded-md"
                    >
                      <Trash2 size={16}/>
                    </button>
                  )}
                </div>

                <FormField
                  label="(1) Folio Number"
                  value={trans.folioNo}
                  onChange={(v) => updateTransaction(trans.id, "folioNo", v)}
                />
                <FormField
                  label="(2) DP Id / Client ID"
                  value={trans.dpIdClientId}
                  onChange={(v) =>
                    updateTransaction(trans.id, "dpIdClientId", v)
                  }
                />
                <FormField
                  label="(3) Certificate Number"
                  value={trans.certNo}
                  onChange={(v) => updateTransaction(trans.id, "certNo", v)}
                />
                <FormField
                  label="(4) Name of last holder of securities"
                  value={trans.holderName}
                  onChange={(v) => updateTransaction(trans.id, "holderName", v)}
                />
                <FormField
                  label="(5) Category of securities"
                  value={trans.category}
                  onChange={(v) => updateTransaction(trans.id, "category", v)}
                />
                <FormField
                  label="(6) Date of buy-back"
                  type="date"
                  value={trans.buyBackDate}
                  onChange={(v) =>
                    updateTransaction(trans.id, "buyBackDate", v)
                  }
                />
                <FormField
                  label="(7) Number of securities bought-back"
                  type="number"
                  value={trans.qty}
                  onChange={(v) => updateTransaction(trans.id, "qty", v)}
                />
                <FormField
                  label="(8) Mode of buy-back"
                  value={trans.mode}
                  onChange={(v) => updateTransaction(trans.id, "mode", v)}
                />
                <FormField
                  label="(9) Nominal value of securities"
                  value={trans.nominalVal}
                  onChange={(v) => updateTransaction(trans.id, "nominalVal", v)}
                />
                <FormField
                  label="(10) Price at which securities are bought back"
                  value={trans.buyPrice}
                  onChange={(v) => updateTransaction(trans.id, "buyPrice", v)}
                />
                <FormField
                  label="(11) Date of payment"
                  type="date"
                  value={trans.payDate}
                  onChange={(v) => updateTransaction(trans.id, "payDate", v)}
                />
                <FormField
                type="number"
                  label="(12) Amount paid for bought back securities"
                  value={trans.totalPaid}
                  onChange={(v) => updateTransaction(trans.id, "totalPaid", v)}
                />
                <FormField
                type="number"
                  label="(13) Cumulative total of securities bought-back"
                  value={trans.cumTotal}
                  onChange={(v) => updateTransaction(trans.id, "cumTotal", v)}
                />
                <FormField
                  label="(14) Date of cancellation / physical destruction"
                  type="date"
                  value={trans.cancelDate}
                  onChange={(v) => updateTransaction(trans.id, "cancelDate", v)}
                />
                <FormField
                  label="(15) Reference to entry in Register of members"
                  value={trans.refMem}
                  onChange={(v) => updateTransaction(trans.id, "refMem", v)}
                />
                <div className="col-span-1 md:col-span-2">
                  <FormField
                    label="(16) Remarks"
                    type="description"
                    value={trans.remarks}
                    onChange={(v) => updateTransaction(trans.id, "remarks", v)}
                  />
                </div>
              </div>
            ))}
          </div>

          {/* Authorized Signatory */}
          <div className="border-t-2 border-slate-100 pt-3">
            <h4 className="font-bold text-base uppercase text-slate-700 mb-2">
              Authorized Signatory
            </h4>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-2">
              <FormField
                label="Name of the Person"
                value={record.header.signatoryName}
                onChange={(v) => updateHeader("signatoryName", v)}
              />
              <FormField
                label="Designation"
                value={record.header.designation}
                onChange={(v) => updateHeader("designation", v)}
              />
              <FormField
                label="Place"
                value={record.header.place}
                onChange={(v) => updateHeader("place", v)}
              />
              <FormField
                label="Date"
                type="date"
                value={record.header.currentDate}
                onChange={(v) => updateHeader("currentDate", v)}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Action Buttons */}
      <div className="flex flex-row justify-end items-center mt-2 mb-2">
        <Button
          label={isSubmitting ? "Saving..." : "Save SH-10 Register"}
          onClick={handleSave}
          disabled={isSubmitting}
          className="mt-2 ml-2 mb-2"
        />
      </div>
    </div>
  );
};

export default ShTenForm;
